import React, { createContext, useContext, useState, useEffect } from "react";

export const FontContext = createContext();

export const FontProvider = ({ children }) => {
    const [fontSchemes, setFontSchemes] = useState({
        scheme_one: "",
        scheme_two: "",
        scheme_three: "",
    });

    useEffect(() => {
        const userAgent = navigator.userAgent.toLowerCase();
        console.log(userAgent);
        let scheme_one = "";
        let scheme_two = "";
        let scheme_three = "";
        if (userAgent.includes("chrome")) {
            console.log("Detected Chrome");
            scheme_one = "chrome_font_scheme_one";
            scheme_two = "chrome_font_scheme_two";
            scheme_three = "chrome_font_scheme_three";
        } else if (userAgent.includes("safari")) {
            console.log("Detected Safari");
            scheme_one = "safari_font_scheme_one";
            scheme_two = "chrome_font_scheme_two";
            scheme_three = "chrome_font_scheme_three";
        } else if (userAgent.includes("firefox")) {
            console.log("Detected Firefox");
            scheme_one = "chrome_font_scheme_one";
            scheme_two = "chrome_font_scheme_two";
            scheme_three = "chrome_font_scheme_three";
        } else {
            console.log("Detected Other Browser");
            scheme_one = "default_font_scheme_one";
            scheme_two = "default_font_scheme_two";
            scheme_three = "default_font_scheme_three";
        }

        setFontSchemes({ scheme_one, scheme_two, scheme_three });
    }, []);

    return (
        <FontContext.Provider value={fontSchemes}>
            {children}
        </FontContext.Provider>
    );
};

export const useFont = () => useContext(FontContext);
